import { useEffect, useCallback } from 'react';
import { thunks } from 'src/thunks/team';
import { useDispatch, useSelector } from '../store/index';
import { useParams } from 'react-router';

export const useGetTeams = () => {
  const dispatch = useDispatch();
  const { teamId } = useParams();

  // Access Redux state
  const team = useSelector((state) => state.team);

  // Check if teams have been fetched using the CRUD status system AND global flag
  const isLoading = team._status?.listTeams?.isFetching || false;
  const hasFetched = team._status?.listTeams?.hasFetched || false;
  const hasInitiallyFetched = team.hasInitiallyFetched || false;

  // Only fetch if not fetched globally in this session
  useEffect(() => {
    if (!hasInitiallyFetched && !isLoading) {
      console.log('🔄 useGetTeams: Fetching teams for first time this session', { teamId });
      dispatch(thunks.getTeams({ teamId }));
    } else {
      console.log('🔄 useGetTeams: Teams already fetched this session, skipping', {
        hasInitiallyFetched,
        isLoading,
        teamId,
      });
    }
  }, [hasInitiallyFetched, isLoading, teamId, dispatch]);

  const fetchTeams = useCallback(async () => {
    console.log('🔄 useGetTeams: Manual refetch requested', { teamId });
    return dispatch(thunks.getTeams({ teamId }));
  }, [dispatch, teamId]);

  return {
    team: team,
    hasFetched,
    isLoading,
    isUnauthorized: false, // We'll handle auth errors in the thunk
    refetch: fetchTeams,
  };
};
